import { Card } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledCard = styled(Card)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  boxShadow: 'none',
  border: '1px solid #f0f0f0',
  borderRadius: '8px',
  '&:last-child': {
    marginBottom: 0
  }
}));

export const HeaderCard = styled(Card)(({ theme }) => ({
  boxShadow: 'none',
  border: 'none',
  borderRadius: '8px',
  marginBottom: theme.spacing(2)
}));

export const SidebarCard = styled(Card)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  boxShadow: 'none',
  border: '1px solid #f0f0f0',
  borderRadius: '8px'
}));

export const styles = {
  container: {
    p: 5,
    maxWidth: '1600px',
    margin: '0 auto',
    maxHeight: 'calc(100vh - 70px)',
    color: '#333'
  },
  headerStack: {
    pb: '16px !important',
    color: '#333'
  },
  sectionTitle: {
    fontWeight: 600,
    fontSize: '18px',
    color: '#333'
  },
  sectionContent: {
    color: '#333'
  },
  highlightCard: {
    border: '1px solid #f0f0f0',
    borderRadius: '8px',
    padding: '16px',
    minHeight: '96px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
  },
  timelineLine: {
    position: 'absolute',
    left: '20px',
    top: '20px',
    bottom: '20px',
    width: '1px',
    backgroundColor: '#ddd'
  },
  tabs: {
    '& .MuiTab-root': {
      alignItems: 'flex-start',
      textTransform: 'none',
      fontSize: '14px',
      fontWeight: 500,
      minWidth: 'auto',
      px: 2,
      py: 0.5
    },
    '& .MuiTab-root.Mui-selected': {
      color: '#084D6D',
      fontWeight: 600
    },
    '& .MuiTab-root:focus': {
      outline: 'none'
    },
    '& .MuiTab-root:focus-visible': {
      outline: 'none'
    },
    '& .MuiTabs-indicator': {
      background: '#5BC4BF',
      left: 0,
      right: 'auto',
      width: '3px'
    }
  },
  tabsIndicator: {
    left: 0,
    right: 'auto',
    width: '3px'
  }
};
